// @flow
import React from 'react';
import { withTranslation } from 'react-i18next';

import { Cactus } from '../../_Icons';
import styles from './Nothing.scss';


type Props = {
  t: (s: string) => string,
}

const Nothing = ({ t }: Props) =>
  <div className={styles.root}>
    <Cactus />
    <div className={styles.msg}>{t('nothing')}</div>
  </div>;


export default withTranslation('children')(Nothing);
